import { DeliveryMethodId, } from '@wix/ambassador-chat-web/types';
export { DeliveryMethodId };
export var UNREAD_CHATROOM_IDS_COUNT_LIMIT_PER_PARTICIPANT = 100;
export var IMessageTypes;
(function (IMessageTypes) {
    IMessageTypes["message"] = "message";
    IMessageTypes["template_standard_event"] = "template/standard-event";
    IMessageTypes["template_minimal"] = "template/minimal";
    IMessageTypes["template_form"] = "template/form";
    IMessageTypes["template_custom"] = "template/custom";
    IMessageTypes["template_system"] = "template/system";
    IMessageTypes["template_unsupported"] = "template/unsupported";
    IMessageTypes["template_deleted"] = "template/deleted";
})(IMessageTypes || (IMessageTypes = {}));
export var OfflineChannelId;
(function (OfflineChannelId) {
    OfflineChannelId["Email"] = "Email";
    OfflineChannelId["Facebook"] = "Facebook";
    OfflineChannelId["Instagram"] = "Instagram";
    OfflineChannelId["SMS"] = "SMS";
    OfflineChannelId["Whatsapp"] = "Whatsapp";
    OfflineChannelId["Phone"] = "Phone";
})(OfflineChannelId || (OfflineChannelId = {}));
